import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';

import { HermesysColors } from '../../../Colors';
import { ButtonPosition } from '../Console';
import usePopup from '../hooks/usePopup';

const ContainerDiv = styled.div`
  background: ${HermesysColors.ButtonBackgroundGray};
  border: outset 3px ${HermesysColors.Gray};
  text-align: left;
`;

const PopupInnerDiv = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  max-height: 104px;
  overflow: hidden;
`;

const RelativeDiv = styled.div`
  position: relative;
`;

const BottomScroller = styled.div`
  position: absolute;
  z-index: 10;
  width: 20px;
  height: 20px;
  right: 0px;
  bottom: 0px;
  color: ${HermesysColors.White};
  background: ${HermesysColors.Blue};
`;

const TopScroller = styled<any>(BottomScroller)`
  top: 0px;
`;

// Idially scrollPos  should be controlled from container to scroll the position, until we have more info on how the scroll
// happens, we are scrolling by clicking on the scroll indicators, this is not how the final system should behave
// TODO: Review
const Scroller = ({
  children,
  scrollPos = 0,
}: {
  children: React.ReactNode;
  scrollPos?: number;
}) => {
  const [scrollable, setScrollable] = useState(false);
  const [scrollerRef, setScrollerRef] = useState<any>(null);
  const [scrollOffset, setScrollOffset] = useState(0);
  const [scrolledToBottom, setScrolledToBottom] = useState(false);

  useEffect(() => {
    if (scrollerRef) {
      const isScrollable = scrollerRef.scrollHeight > scrollerRef.clientHeight;
      setScrollable(isScrollable);
    }
  }, [scrollerRef]);

  useEffect(() => {
    if (scrollerRef) {
      setScrolledToBottom(
        scrollerRef.scrollHeight - scrollerRef.scrollTop ===
          scrollerRef.clientHeight
      );
    }
  }, [scrollOffset]);

  const scrollDown = () => {
    if (scrollerRef) {
      scrollerRef.scroll(0, scrollOffset + 20);
      setScrollOffset(scrollerRef.scrollTop);
    }
  };
  const scrollUp = () => {
    if (scrollerRef) {
      scrollerRef.scroll(0, scrollOffset - 20);
      setScrollOffset(scrollerRef.scrollTop);
    }
  };
  return (
    <ContainerDiv>
      <RelativeDiv>
        {scrollable && scrollOffset > 0 && (
          <TopScroller onClick={scrollUp}>
            <ArrowDropUpIcon />
          </TopScroller>
        )}
        <PopupInnerDiv ref={setScrollerRef}>{children}</PopupInnerDiv>
        {scrollable && !scrolledToBottom && (
          <BottomScroller onClick={scrollDown}>
            <ArrowDropDownIcon />
          </BottomScroller>
        )}
      </RelativeDiv>
    </ContainerDiv>
  );
};

export default Scroller;
